import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_DEVISE = 'EUR';

const normalizeDevise = (value) => {
  if (typeof value === 'string' && value && value !== '---') {
    return value;
  }
  if (value && typeof value === 'object' && typeof value.devise === 'string') {
    return value.devise;
  }
  return DEFAULT_DEVISE;
};

const readStoredDevise = () => {
  try {
    const raw = localStorage.getItem('deviseInfo');
    if (!raw) return DEFAULT_DEVISE;
    return normalizeDevise(JSON.parse(raw));
  } catch {
    return DEFAULT_DEVISE;
  }
};

const initialState = {
  deviseInfo: readStoredDevise(),
};

const deviseSlice = createSlice({
  name: 'devise',
  initialState,
  reducers: {
    setCredentialDevise: (state, action) => {
      const next = normalizeDevise(action.payload);
      state.deviseInfo = next;
      localStorage.setItem('deviseInfo', JSON.stringify(next));
    },
  },
});

export const { setCredentialDevise } = deviseSlice.actions;

export default deviseSlice.reducer;
